import React, { useState, useRef, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button } from 'react-bootstrap';
import { PermissionContext } from '../../../hooks/PermissionContext';
import { Show } from '../../../hooks/Show';
import Grid from '../../../components/Grid';
import ReschedulingSolutionModal from '../../../components/Modal/ReschedulingSolutionModal';
import getHistoryColumns from './columns';

const Swal = require('sweetalert2');

const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const HistoryToReschedule = ({
    reduxGetHistoryToReschedule,
    reduxResetShipmentPendingToReschedule,
    shipmentsPendingToReschedule,
    reduxGetAddress,
    rowEdited,
    reschedule,
    currentTab,
}) => {
    const {
        register: registerSearch,
        handleSubmit: handleSubmitSearch,
        reset: resetSearch,
        setValue: setValueSearch,
        getValues: getValuesSearch,
    } = useForm({
        defaultValues: {
            from: null,
            to: null,
            search: '',
        }
    });

    const { hasPermission } = useContext(PermissionContext);

    const [currentPage, setCurrentPage] = useState(1);
    const [offset, setOffset] = useState(10);
    const [search, setSearch] = useState('');
    const [showModalReschedule, setShowModalReschedule] = useState(false);
    const [dateRange, setDateRange] = useState(() => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 20);
        return [startDate, endDate];
    });

    const [startDate, endDate] = dateRange;
    const rangeRef = useRef(null);
    const [filters, setFilters] = useState({});

    useEffect(() => {
        if (!shipmentsPendingToReschedule || Object.keys(shipmentsPendingToReschedule).length < 1) {
            reduxGetHistoryToReschedule({
                page: currentPage,
                offset: offset,
                search: search,
                from: formatDate(startDate),
                to: formatDate(endDate),
            });
            return;
        }

        reduxGetHistoryToReschedule({
            page: currentPage,
            offset: offset,
            search: search,
            from: formatDate(startDate),
            to: formatDate(endDate),
        });

        setShowModalReschedule(false);

        return () => {
            reduxResetShipmentPendingToReschedule();
        };
    }, [currentPage, reschedule]);

    const onChangeDate = (dates) => {
        const [start, end] = dates;
        setDateRange(dates);
        rangeRef.current.handleFocus();
    };

    const onSubmitSearch = () => {
        if (endDate < startDate) {
            Swal.fire('Información', 'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo', 'info');
            return;
        }
        let filters = {
            page: 1,
            search: search ? search : '',
            offset: offset,
        };
        if (dateRange && dateRange.length > 0 && startDate && endDate) {
            filters = {
                ...filters,
                from: formatDate(startDate),
                to: formatDate(endDate),
            };
        }
        reduxGetHistoryToReschedule(filters);
    };

    const openReschedule = (row) => {
        reduxGetAddress({ id: row.idAddress });
        setShowModalReschedule(true);
    };

    const handleCloseReschedule = () => {
        setShowModalReschedule(false);
    };

    const columns = getHistoryColumns({ hasPermission, openReschedule, Show });

    return (
        <div>
            <div>
                <div className='card shadow mb-4'>
                    <div className='card-header py-3 d-flex justify-content-between'>
                        <h6 className='m-0 font-weight-bold text-primary'>Historico para Reprogramaciones</h6>
                    </div>
                    <div className='card-body'>
                        <form onSubmit={handleSubmitSearch(onSubmitSearch)}>
                            <div className='row mb-1'>
                                <div className='form-group col-md-3'>
                                    <label className='form-label'>
                                        Desde - Hasta
                                    </label>
                                    <DatePicker
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange
                                        ref={rangeRef}
                                        selectsDisabledDaysInRange
                                        onChange={onChangeDate}
                                        dateFormat="yyyy-MM-dd"
                                        className={'form-control'}
                                        maxDate={new Date()}
                                        shouldCloseOnSelect={false}
                                        isClearable
                                    />
                                </div>

                                <div className='form-group d-flex flex-row align-items-end ml-3'>
                                    <Button
                                        className='mr-2'
                                        variant='primary'
                                        type='submit'
                                        id='btnSearch'>
                                        Buscar
                                    </Button>
                                </div>
                            </div>
                        </form>
                        <Grid
                            className='stickyAddress'
                            cols={columns}
                            data={shipmentsPendingToReschedule && Object.keys(shipmentsPendingToReschedule).length > 0 ? shipmentsPendingToReschedule.items : []}
                            total={shipmentsPendingToReschedule && shipmentsPendingToReschedule.hasOwnProperty('total') ? shipmentsPendingToReschedule.total : 0}
                            page={shipmentsPendingToReschedule && Object.keys(shipmentsPendingToReschedule).length > 0 ? Number(shipmentsPendingToReschedule.page) : currentPage}
                            pages={shipmentsPendingToReschedule && Object.keys(shipmentsPendingToReschedule).length > 0 ? Number(shipmentsPendingToReschedule.totalPages) : 0}
                            offset={offset}
                            onChangePage={(page) => setCurrentPage(page)}
                            onChangeRange={(value) => {
                                setOffset(value);
                                setCurrentPage(1);
                                let filters = {
                                    page: 1,
                                    offset: value,
                                    search: search,
                                    from: startDate ? formatDate(startDate) : null,
                                    to: endDate ? formatDate(endDate) : null,
                                };
                                reduxGetHistoryToReschedule({ ...filters });
                            }}
                            defaultValue={search}
                            onChangeSearch={(value) => {
                                setSearch(value);
                                setCurrentPage(1);
                                let filters = {
                                    page: 1,
                                    offset: offset,
                                    search: value,
                                    from: startDate ? formatDate(startDate) : null,
                                    to: endDate ? formatDate(endDate) : null,
                                };
                                reduxGetHistoryToReschedule({ ...filters });
                            }}
                        />
                    </div>
                </div>
            </div>
            <ReschedulingSolutionModal
                show={showModalReschedule}
                onHide={handleCloseReschedule}
                onEscapeKeyDown={handleCloseReschedule}
                valueManualAddressProp={''}
                currentTab={'historyToReschedule'}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        shipmentsPendingToReschedule: state.addressState.shipmentsPendingToReschedule,
        rowEdited: state.addressState.rowEdited,
        reschedule: state.addressState.reschedule,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reduxGetHistoryToReschedule: (payload) =>
            dispatch({
                type: 'FETCH_HISTORY_SHIPMENTS_TO_RESCHEDULE_REQUEST',
                value: payload,
            }),
        reduxGetAddress: (payload) =>
            dispatch({
                type: 'READ_ADDRESS_REQUEST',
                value: payload,
            }),
        reduxResetShipmentPendingToReschedule: () =>
            dispatch({
                type: 'RESET_SHIPMENTS_HISTORY_TO_RESCHEDULE',
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryToReschedule);
